import type { Difficulty } from '@/types';

export const BALANCE = {
  elephant: {
    startStage: 0,
    maxStage: 4,
    progressPerStage: 100,
    progressOnHit: 50,
    scales: [0.5, 0.7, 1.0, 1.3, 1.6],
    multipliers: [1.0, 1.1, 1.25, 1.5, 2.0],
    hitboxSizes: [30, 42, 60, 78, 96],
    shieldDurationMs: 5000,
    shieldWarnThresholdMs: 1000,
    hurtAnimDurationMs: 800,
    levelUpAnimDurationMs: 400,
  },
  lanes: {
    count: 3,
    positions: [60, 180, 300] as const,
    swipeThresholdPx: 30,
    swipeMaxDurationMs: 300,
    laneChangeAnimDurationMs: 200,
  },
  spawn: {
    phases: [
      {
        startMs: 0,
        endMs: 20000,
        intervalMs: 1400,
        scrollSpeed: 200,
        difficulties: ['easy'] as Difficulty[],
      },
      {
        startMs: 20000,
        endMs: 40000,
        intervalMs: 1200,
        scrollSpeed: 280,
        difficulties: ['easy', 'medium'] as Difficulty[],
      },
      {
        startMs: 40000,
        endMs: 60000,
        intervalMs: 950,
        scrollSpeed: 360,
        difficulties: ['easy', 'medium', 'hard'] as Difficulty[],
      },
    ],
    // First shield delayed để arrival align với phase 1 monster appearance (~23s)
    firstShieldMinMs: 22000,
    firstShieldMaxMs: 28000,
    shieldIntervalMinMs: 15000,
    shieldIntervalMaxMs: 20000,
    despawnY: 700,
    spawnY: -50,
  },
  game: {
    durationMs: 60000,
    timeBonus: 50,
    countdownMs: 3000,
    elephantY: 480,
    slowMoBeforeGameOverMs: 500,
  },
  ui: {
    tooltipDurationMs: 1500,
    tooltipFadeInMs: 200,
    tooltipFadeOutMs: 300,
    timerWarnSecondsLeft: 10,
  },
} as const;

export type BalanceConfig = typeof BALANCE;
